<template>
  <section class="home_feacture_sec">
    <hr class="line" />
    <div class="feature_sec">
      <h2 class="sec_heading" v-html="shopifyData.secHeading" />
      <ul class="feature_list">
        <li v-for="(value, key) in shopifyData.block" :key="key" class="feature_item">
          <a class="feature_link" :href="value.productLink">
            <img
              v-lazy="value.imgUrl.src"
              class="bags"
              loading="lazy"
              aria-hidden="true"
              aria-label="Product Image"
              width=""
              height=""
              :alt="value.imgUrl.alt || 'Product Image'"
              :placeholder="value.imgUrl.placeholder"
            />
          </a>
        </li>
      </ul>
    </div>
    <hr class="line" />
  </section>
</template>

<script>
export default {
  props: {
    shopifyData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.home_feacture_sec {
  margin: 30px 0;
}
.bags {
  width: 100%;
  max-width: 321px;
}

.feature_sec {
  padding: 0 5% 0 2%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 20px 70px;
}
.sec_heading {
  font-size: 22px;
  font-weight: 400;
  font-family: 'Helvetica Neue', sans-serif;
  white-space: nowrap;
  align-self: baseline;
  margin: 44px 0 0;
}

.feature_list {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
}

.feature_link {
  display: block;
  text-align: center;
}

.line {
  width: calc(100% - 2%);
  margin: 0 auto;
  border-top: 1px solid #000;
}

@media screen and (max-width: 1200px) {
  .feature_sec {
    display: block;
    padding: 0 2%;
  }
}
@media screen and (max-width: 991px) {
  .feature_list {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
@media screen and (max-width: 480px) {
  .sec_heading {
    font-size: 18px;
    margin: 0 0 15px;
  }
  .feature_list {
    display: grid;
    grid-template-columns: 1fr;
  }

  .feature_item {
    margin: 0 15px;
    border-bottom: 1px solid black;
  }
  .feature_item:last-child {
    border-bottom: none;
  }
}
</style>
